export default __webpack_public_path__ + "static/media/score-cards-streak-inactive.28007ee8.svg";